<template>
  <!-- Messages inbox (Android InboxFragment): chats with consumers, newest first; a row opens the chat -->
  <div class="w-full font-roboto">
    <div
      class="relative border-1 rounded-2xl min-w-full min-h-[60vh] flex flex-col gap-[10px] px-2 laptop:px-3 pt-8 pb-5 border-gray-300">
      <button type="button" aria-label="Back"
        class="laptop:hidden absolute -top-[20px] left-[10px] z-[3] w-[40px] h-[40px] p-0 rounded-full border-0 flex items-center justify-center bg-[#666666] shadow-[0px_0px_10px_0px_#00000026]"
        @click="$router.back()">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M19 12H5M11 6l-6 6 6 6" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <!-- same "Show entries" + pager as the Work Order listings -->
      <div class="flex justify-end absolute -top-[20px] right-[10px]">
        <entities :model-value="limit" global-entities-class="" @update:model-value="onLimitChange" />
      </div>
      <button v-for="item in items" :key="item.id" type="button"
        class="w-full flex items-center gap-[12px] px-[15px] py-[12px] rounded-[15px] bg-white shadow-[0px_0px_10px_0px_#0000001A] border-0 text-left hover:shadow-[0px_0px_10px_0px_#00000033] transition"
        @click="openChat(item)">
        <img :src="item.consumer?.profile_picture || defaultAvatar" alt=""
          class="w-[50px] h-[50px] rounded-full object-cover flex-shrink-0 bg-[#EFEFEF]">
        <div class="flex-1 min-w-0">
          <div class="flex items-center justify-between gap-[10px]">
            <p class="m-0 text-[16px] font-medium text-[#333333] truncate">{{ item.consumer?.full_name || '-' }}</p>
            <span class="flex-shrink-0 text-[12px] text-[#999999]">{{ formatDate(item.message_time) }}</span>
          </div>
          <p class="m-0 mt-[2px] text-[14px] text-[#666666] truncate">{{ item.message || '' }}</p>
          <p class="m-0 mt-[2px] text-[12px] text-[#7695FF]">
            {{ item.type === 'order' ? 'Replacement Quote' : (item.type === 'booking' ? 'Service & Repair' : 'Quote')
            }}: {{ item.booking_id }}
          </p>
        </div>
      </button>

      <EmptyState v-if="loaded && !items.length" min-height="min-h-[55vh]" />

    </div>
    <div v-if="items.length > 0"
      class="flex mobile:flex-col tablet:flex-row mobile:gap-3 tablet:gap-0 items-center justify-between relative -top-5 px-3">
      <paginationEntries class="mobile:hidden tablet:block" :current-page="page" :per-page="limit"
        :total-items="totalItems" />
      <customPagination :page="page" :total_pages="totalPages" :update-page="load" />
    </div>

    <ChatWindow ref="chat" @closed="onChatClosed" />
  </div>
</template>

<script>
import EmptyState from "@/components/partialComponent/EmptyState.vue";
import { useToast } from "vue-toastification";
import ChatWindow from "../../components/chat/ChatWindow.vue";
import entities from "../../components/showEntities/entities.vue";
import customPagination from "../../components/partialComponent/customPagination.vue";
import paginationEntries from "../../components/partialComponent/pagination-entries.vue";
import { inboxApi } from "../../services/inboxApi";

const toast = useToast();
const pad = (n) => String(n).padStart(2, "0");

export default {
  components: { EmptyState, ChatWindow, entities, customPagination, paginationEntries },
  data() {
    return {
      items: [],
      page: 1,
      limit: 25,
      totalPages: 0,
      totalItems: 0,
      loading: false,
      loaded: false,
      defaultAvatar: "https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg",
    };
  },
  mounted() {
    this.load(1);
  },
  methods: {
    async load(page) {
      if (this.loading) return;
      this.loading = true;
      const res = await inboxApi.list(page, this.limit);
      this.loading = false;
      this.loaded = true;
      if (!res.ok) {
        toast.error(res.message || "Unable to load messages.");
        return;
      }
      const rows = Array.isArray(res.body) ? res.body : [];
      this.items = rows;
      this.page = page;
      this.totalPages = Number(res.paging?.total_pages) || (rows.length ? page : 0);
      this.totalItems = Number(res.paging?.total_records) || rows.length;
    },
    onLimitChange(newLimit) {
      this.limit = newLimit;
      this.load(1);
    },
    openChat(inbox) {
      this.$refs.chat.open({ inbox });
    },
    onChatClosed({ sent } = {}) {
      if (sent) this.load(this.page);
    },
    // message_time is a unix timestamp (seconds) → MM/DD/YYYY
    formatDate(seconds) {
      const n = Number(seconds);
      if (!n) return "";
      const d = new Date(n * 1000);
      return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()}`;
    },
  },
};
</script>
